var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatNewYoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-212-1-copy",
    transform: "translate(-55.000000, -211.000000)",
    fill: "#d49830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(55.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "9.39322583 2 15.6021953 2.89061874 20.7629146 6.04496306 23 10.98346 21.5598659 15.6890819 17.8633053 19.1113524 14.1020597 20.1329083 6.33764393 20.7447772 3.79869595 22 4.63793164 18.4905169 1.94074716 15.2173051 -3.1918912e-16 12 1.09139512 8.59774029 2.73132627 5.42227048 4.63793164 4.00891494 7.09312572 2.89061874"
  }), /*#__PURE__*/React.createElement("g", {
    id: "1)-Icon/Share-Android/32px-Line",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2581877,20.093227 C6.36650588,21.7532 4.34787816,22.1895931 2.61493662,21.9308627 C2.45241888,21.9065985 2.32978794,21.8805088 2.25126226,21.8592947 C1.47840623,21.6505042 1.40311109,20.6038574 2.13840833,20.2905584 C3.1659658,19.8527319 3.78184912,19.0425079 4.08507396,18.0307262 C1.51928078,16.1007438 0,13.3085062 0,10.292351 C0,4.57852471 5.39768307,-1.11022302e-16 12,-1.11022302e-16 C18.6023169,-1.11022302e-16 24,4.57852471 24,10.292351 C24,16.005649 18.6020049,20.584702 12,20.584702 C10.7196875,20.584702 9.4662731,20.4128504 8.27369698,20.0795855 C8.26852992,20.084141 8.26336016,20.0886881 8.2581877,20.093227 Z M7.12567857,18.8500645 C7.2333704,18.7555636 7.34000633,18.6562858 7.44553503,18.552125 C7.67188588,18.3287083 8.00721937,18.2495918 8.31230454,18.3476247 C9.47887581,18.7224789 10.7225628,18.9171002 12,18.9171002 C17.7141802,18.9171002 22.300885,15.0262549 22.300885,10.292351 C22.300885,5.55794336 17.71451,1.66760177 12,1.66760177 C6.28548997,1.66760177 1.69911504,5.55794336 1.69911504,10.292351 C1.69911504,12.919517 3.11593677,15.3638935 5.525026,16.9974173 C5.80115411,17.1846506 5.93909033,17.5138817 5.87703144,17.8375965 C5.71711586,18.6717564 5.41746247,19.4476855 4.95047245,20.1134197 C5.66196849,19.8915156 6.39817856,19.4884542 7.12567857,18.8500645 Z",
    id: "Icon-Color"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNewYoli);
export default __webpack_public_path__ + "static/media/chat_new_Yoli.9cb1a3af67d69beec1a037bee9842f13.svg";
export { ForwardRef as ReactComponent };